function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * New list / Edit list dialog (BULK_EMAIL_MANAGEMENT §7.1; redesign 2026-10-09 board 3 "New list").
 * Name, optional "What it's for", then "How people get in" as two choice cards: Fills itself (dynamic, a rule)
 * or I'll add people (static). The rule reads as a sentence with a live count box beside it.
 *   POST /v1/audience/create {name, kind, ruleJson, description}  → 400 {error, fields} on an invalid rule, 409 duplicate
 *   PUT  /v1/audience/{id}   {name, ruleJson, description}        (a rule on a static list turns it dynamic)
 *   POST /v1/audience/{id}/snapshot {name}                        → a new static list from a dynamic one (edit mode)
 *   POST /v1/audience/{id}/convert {kind:"dynamic", ruleJson}     (mode="convert": a static list becomes dynamic)
 * Props: audience (edit) | null (create); lists (for in_list pickers); mode ("convert"); onClose; onSaved(audience)
 */
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { createAudience, updateAudience, listAudiences, snapshotAudience, convertAudience, toast } from "./api";
import RuleBuilder, { parseRule, toRuleJson, validateRule, emptyGroup } from "./rule-builder";
import { Modal, ErrorLine } from "./ui";
export const KIND_CARDS = [{
  v: "dynamic",
  title: "Fills itself",
  copy: "People who match what you describe. Updated every night."
}, {
  v: "static",
  title: "I'll add people",
  copy: "Upload a file, paste addresses or copy from another list."
}];

/** "How people get in": two choice cards. */
export function KindCards({
  value,
  onChange,
  locked
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ane-kinds",
    role: "radiogroup",
    "aria-label": "How people get in"
  }, KIND_CARDS.map(k => {
    const sel = value === k.v;
    const off = locked && !sel;
    return /*#__PURE__*/React.createElement("label", {
      key: k.v,
      className: `ane-kind${sel ? " sel" : ""}${off ? " off" : ""}`
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "ane-kind",
      value: k.v,
      checked: sel,
      disabled: off,
      onChange: () => !off && onChange(k.v)
    }), /*#__PURE__*/React.createElement("b", null, k.title), /*#__PURE__*/React.createElement("span", null, k.copy));
  }));
}
export default class ListEditor extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "save", async () => {
      const {
        name,
        kind,
        description,
        tree
      } = this.state;
      const a = this.props.audience;
      const convert = this.props.mode === "convert";
      if (!name.trim()) {
        this.setState({
          err: "Give the list a name."
        });
        return;
      }
      let ruleJson;
      if (kind === "dynamic") {
        const v = validateRule(tree);
        if (v) {
          this.setState({
            err: v
          });
          return;
        }
        ruleJson = toRuleJson(tree);
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        let saved;
        if (convert) {
          saved = await convertAudience(String(a.id), {
            kind: "dynamic",
            ruleJson
          });
        } else if (a) {
          const body = {
            description: description.trim()
          };
          if (name.trim() !== a.name) body.name = name.trim();
          if (kind === "dynamic") body.ruleJson = ruleJson;
          saved = await updateAudience(String(a.id), body);
        } else {
          saved = await createAudience({
            name: name.trim(),
            kind,
            ruleJson,
            description: description.trim() || undefined
          });
        }
        this.props.onSaved && this.props.onSaved(saved && saved.id !== undefined ? saved : {
          ...(a || {}),
          name: name.trim(),
          kind,
          description,
          ruleJson
        });
      } catch (e) {
        const fields = e.data && e.data.fields;
        this.setState({
          err: e.status === 409 ? `There is already a list called “${name.trim()}”. Pick another name.` : (e.message || "Could not save.") + (fields && fields.length ? " Check the lines in How people get in." : "")
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "snapshot", async () => {
      const a = this.props.audience;
      const name = this.state.snapName.trim();
      if (!name) {
        this.setState({
          err: "Give the copy a name."
        });
        return;
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const r = await snapshotAudience(String(a.id), name);
        toast(`“${r && r.name || name}” created${r && r.total != null ? ` with ${Number(r.total).toLocaleString("en-US")} people` : ""}.`);
        this.props.onSnapshot && this.props.onSnapshot(r);
        this.setState({
          snapOpen: false
        });
      } catch (e) {
        this.setState({
          err: e.message || "Could not make the copy."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    const _a = props.audience;
    const _convert = props.mode === "convert";
    this.state = {
      name: _a ? _a.name || "" : "",
      kind: _convert ? "dynamic" : _a ? _a.kind || "static" : "dynamic",
      description: _a ? _a.description || "" : "",
      tree: _a && _a.ruleJson ? parseRule(_a.ruleJson) : emptyGroup(),
      lists: props.lists || null,
      busy: false,
      err: "",
      snapOpen: false,
      snapName: _a ? `${_a.name} (copy)` : ""
    };
    this._alive = true;
  }
  componentDidMount() {
    if (!this.state.lists) listAudiences().then(r => {
      if (this._alive) this.setState({
        lists: Array.isArray(r) ? r : r && r.items || []
      });
    }).catch(() => {});
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      name,
      kind,
      description,
      tree,
      lists,
      busy,
      err,
      snapOpen,
      snapName
    } = this.state;
    const a = this.props.audience;
    const convert = this.props.mode === "convert";
    const editing = !!a && !convert;
    const kindLocked = convert || editing && (a.kind === "dynamic" || a.kind === "mirror" || a.kind === "system");
    const title = convert ? `Make “${a.name}” fill itself` : editing ? `Change “${a.name}”` : "New list";
    const note = convert ? "The people in it now are replaced by the people who match." : kind === "dynamic" ? "People who asked not to get email stay in the list for ads and reports but are never emailed." : editing ? null : "After you create it, add people with a file, pasted addresses or another list.";
    return /*#__PURE__*/React.createElement(Modal, {
      title: title,
      width: kind === "dynamic" ? 1000 : 620,
      onClose: this.props.onClose,
      busy: busy,
      note: note,
      footer: /*#__PURE__*/React.createElement(React.Fragment, null, editing && a.kind === "dynamic" && !snapOpen ? /*#__PURE__*/React.createElement(Button, {
        disabled: busy,
        onClick: () => this.setState({
          snapOpen: true,
          err: ""
        })
      }, "Make a copy") : null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onClose,
        disabled: busy
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        themeColor: "primary",
        onClick: this.save,
        disabled: busy
      }, busy ? "Saving…" : convert ? "Make it fill itself" : editing ? "Save" : "Create list"))
    }, /*#__PURE__*/React.createElement("div", {
      className: "ane"
    }, !convert ? /*#__PURE__*/React.createElement("div", {
      className: "ane-card ane-names"
    }, /*#__PURE__*/React.createElement("label", {
      className: "ane-label",
      htmlFor: "ane-name"
    }, "Name"), /*#__PURE__*/React.createElement("input", {
      id: "ane-name",
      className: "ane-in ane-wide",
      autoFocus: true,
      value: name,
      onChange: e => this.setState({
        name: e.target.value
      }),
      placeholder: "For example: Repeat buyers"
    }), /*#__PURE__*/React.createElement("label", {
      className: "ane-label",
      htmlFor: "ane-desc"
    }, "What it's for ", /*#__PURE__*/React.createElement("span", {
      className: "ane-muted"
    }, "(optional)")), /*#__PURE__*/React.createElement("input", {
      id: "ane-desc",
      className: "ane-in ane-wide",
      value: description,
      onChange: e => this.setState({
        description: e.target.value
      }),
      placeholder: "For example: People we follow up with each month",
      maxLength: 500
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "ane-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ane-card-title"
    }, "How people get in"), !convert ? /*#__PURE__*/React.createElement(KindCards, {
      value: kind,
      onChange: v => this.setState({
        kind: v
      }),
      locked: kindLocked
    }) : null, kind === "dynamic" ? /*#__PURE__*/React.createElement(RuleBuilder, {
      value: tree,
      onChange: t => this.setState({
        tree: t
      }),
      lists: (lists || []).filter(l => !a || String(l.id) !== String(a.id))
    }) : null), snapOpen ? /*#__PURE__*/React.createElement("div", {
      className: "ane-card"
    }, /*#__PURE__*/React.createElement("label", {
      className: "ane-label",
      htmlFor: "ane-snap"
    }, "Name for the copy"), /*#__PURE__*/React.createElement("input", {
      id: "ane-snap",
      className: "ane-in ane-wide",
      autoFocus: true,
      value: snapName,
      onChange: e => this.setState({
        snapName: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "ane-muted"
    }, "Copies today's people into a new list you add people to by hand. This list keeps updating."), /*#__PURE__*/React.createElement("div", {
      className: "ane-btns"
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: this.snapshot
    }, busy ? "Copying…" : "Make the copy"), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setState({
        snapOpen: false
      })
    }, "Cancel"))) : null, /*#__PURE__*/React.createElement(ErrorLine, null, err)));
  }
}